import styled from 'styled-components';

export const Wrapper = styled.div<{ $goBackHidden: boolean }>`
  display: flex;
  justify-content: ${({ $goBackHidden }) => ($goBackHidden ? 'flex-end' : 'space-between')};
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const ButtonsGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
`;

export const WelcomeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
